export default __webpack_public_path__ + "static/media/team_carousel1-mobile.png";